import React from "react";
import { Link } from "react-router-dom";
import "./FooterSection.css";
import footerBg from "../../Image/Footer/Footer.png";

const FooterSection = () => {
  return (
    <footer className="footer_section" style={{ backgroundImage: `url(${footerBg})` }}>
      <div className="footer_container">
        <div className="footer_content_grid">
          {/* Left Column - Both Explore AND Contact us */}
          <div className="footer_column footer_nav_column">
            {/* Explore Section */}
            <div className="footer_first_section">
              <b4 className="footer_column_title">Explore</b4>
              <ul className="footer_nav_list">
                <li className="footer_nav_item">
                  <a href="#about" className="footer_nav_link">
                    About us
                  </a>
                </li>
                <li className="footer_nav_item">
                  <a
                    href="https://www.instagram.com/instasnap.in?igsh=MXIxZDJqdzloODJmag=="
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer_nav_link"
                  >
                    Instagram
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div className="footer_contact_column">
              <b4 className="footer_column_title">Contact us</b4>
              <div className="footer_contact_info">
                <a
                  href="mailto:hello@instasnap.in"
                  className="footer_contact_link"
                >
                  hello@instasnap.in
                </a>
                <a href="tel:08062180170" className="footer_contact_link">
                  0806-218-0170 
                </a>
              </div>
            </div>
          </div>

          {/* Right Column - Locations */}
          <div className="footer_column footer_locations_column">
            <div className="footer_location_item">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="location_icon"
              >
                <path
                  d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle cx="12" cy="9" r="2.5" stroke="white" strokeWidth="2" />
              </svg>
              <a
                href="https://share.google/cUSbcZRY2iMMsr0KB"
                target="_blank"
                rel="noopener noreferrer"
                className="location_link"
              >
                1st Floor, Ameerpet Metro Station, Hyderabad
              </a>
            </div>
            <div className="footer_location_item">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="location_icon"
              >
                <path
                  d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle cx="12" cy="9" r="2.5" stroke="white" strokeWidth="2" />
              </svg>
              <a
                href="https://share.google/C6rd9TJod7IwVTONU"
                target="_blank"
                rel="noopener noreferrer"
                className="location_link"
              >
                1st Floor, Hyderabad Central Mall, Hyderabad
              </a>
            </div>
            <div className="footer_location_item">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="location_icon"
              >
                <path
                  d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle cx="12" cy="9" r="2.5" stroke="white" strokeWidth="2" />
              </svg>
              <a
                href="https://share.google/DxcMkmmtuLSMjntrP"
                target="_blank"
                rel="noopener noreferrer"
                className="location_link"
              >
                5th Floor, Next Galleria Mall, Punjagutta, Hyderabad
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom - Logo and Legal */}
        <div className="footer_bottom">
          <Link
              to="/"
              className="footer_logo_wrapper footer_logo_link"
              onClick={() => window.scrollTo(0, 0)}
            >
              <h2 className="footer_logo">
                Insta<span className="footer_logo_highlight">Snap</span>
              </h2>
              <span className="footer_trademark">TM</span>
            </Link>

          <div className="footer_legal">
            <div className="footer_legal_row">
              <p className="footer_copyright">© 2026 Instasnap</p>
              <span className="footer_separator">|</span>
              <p className="footer_copyright">Bhavel Tech LLP</p>
              <span className="footer_separator">|</span>
              <p className="footer_copyright">GSTIN: 36ABEFB6444L1Z7</p>
              <span className="footer_separator">|</span>
              <Link to="/terms" className="footer_legal_link">
                Terms & Conditions
              </Link>
              <span className="footer_separator">|</span>
              <Link to="/privacy" className="footer_legal_link privacy">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>

    
      </div>
    </footer>
  );
};

export default FooterSection;
